import { Routes, Route } from 'react-router-dom'
import { NotFound } from 'components/ideal-core-ui'
import { DashboardContainer } from '../Dashboard'
import { DealsContainer } from '../Deals'
import { DealContainer } from '../Deal'
import { ProposalsContainer } from '../proposals/Proposals'
import { ProposalContainer } from '../proposals/Proposal'
import { ContactContainer } from '../Contact'
import { ContactsContainer } from '../Contacts'
import { CompanyContainer } from '../Company'
import { CompaniesContainer } from '../Companies'
import { Lists } from '../Lists'
import { CalendarContainer } from '../Calendar'
import { Admin } from '../Admin'
import { GlobalSearch } from '../GlobalSearch'
import { Login } from '../Login'
import { Home } from '../Home'
import { ResetPasswordContainer } from '../ResetPassword'
import { ChangePasswordContainer } from '../ChangePassword'
import { OrganizationRegistration } from '../OrganizationRegistration'
import { LayoutContainer } from '../Layout'
import { URLS } from 'utils/constants'
import { PrivateRoute } from 'components/utils/PrivateRoute'
import { Reports } from '../Reports'
import { DealsBoard } from '../Deals/DealsBoard'
import { DealsList } from '../Deals/DealsList'
import { Leads, Lead } from '../Leads'
import { TimeTracking } from '../TimeTracking'
import { isOnlyTimetracker } from 'utils/authService'

const App = () => {
  return (
    <LayoutContainer>
      <Routes>
        {/* private routes */}
        <Route
          path={URLS.AUTH_HOME}
          element={<PrivateRoute component={Home} restricted={isOnlyTimetracker()} />}
        />
        <Route
          path={URLS.AUTH_DASHBOARD}
          element={<PrivateRoute component={DashboardContainer} restricted={isOnlyTimetracker()} />}
        />
        <Route
          path={URLS.AUTH_LEADS}
          element={
            <PrivateRoute component={Leads} hasModuleOn="leads" restricted={isOnlyTimetracker()} />
          }
        >
          <Route path={URLS.AUTH_LEAD} element={<Lead />} />
        </Route>
        <Route
          path={URLS.AUTH_DEALS}
          element={<PrivateRoute component={DealsContainer} restricted={isOnlyTimetracker()} />}
        >
          <Route index element={<DealsBoard />} />
          <Route path={URLS.AUTH_DEALS_BOARD} element={<DealsBoard />} />
          <Route path={URLS.AUTH_DEALS_LIST} element={<DealsList />} />
        </Route>
        <Route
          path={URLS.AUTH_ROUTES_DEAL}
          element={<PrivateRoute component={DealContainer} restricted={isOnlyTimetracker()} />}
        />
        <Route
          path={URLS.AUTH_PROPOSALS}
          element={<PrivateRoute component={ProposalsContainer} restricted={isOnlyTimetracker()} />}
        />
        <Route
          path={URLS.AUTH_PROPOSAL}
          element={<PrivateRoute component={ProposalContainer} restricted={isOnlyTimetracker()} />}
        />
        <Route
          path={URLS.AUTH_CONTACTS}
          element={<PrivateRoute component={ContactsContainer} restricted={isOnlyTimetracker()} />}
        />
        <Route
          path={URLS.AUTH_CONTACT}
          element={<PrivateRoute component={ContactContainer} restricted={isOnlyTimetracker()} />}
        />
        <Route
          path={URLS.AUTH_COMPANY}
          element={<PrivateRoute component={CompanyContainer} restricted={isOnlyTimetracker()} />}
        />
        <Route
          path={URLS.AUTH_COMPANIES}
          element={<PrivateRoute component={CompaniesContainer} restricted={isOnlyTimetracker()} />}
        />
        <Route
          path={URLS.AUTH_LISTS}
          element={<PrivateRoute component={Lists} restricted={isOnlyTimetracker()} />}
        />
        <Route
          path={URLS.AUTH_CALENDAR}
          element={<PrivateRoute component={CalendarContainer} restricted={isOnlyTimetracker()} />}
        />
        <Route
          path={URLS.AUTH_ADMIN}
          element={<PrivateRoute component={Admin} restricted={isOnlyTimetracker()} />}
        />
        <Route
          path={URLS.AUTH_GLOBAL_SEARCH}
          element={<PrivateRoute component={GlobalSearch} restricted={isOnlyTimetracker()} />}
        />
        <Route
          path={URLS.AUTH_ROUTES_REPORTS}
          element={
            <PrivateRoute component={Reports} allow="ROLE_ADMIN" restricted={isOnlyTimetracker()} />
          }
        />
        <Route
          path={URLS.AUTH_TIME_TRACKING}
          element={
            <PrivateRoute
              component={TimeTracking}
              allow="ROLE_TIMETRACKER ROLE_TIMETRACKER_ADMIN"
            />
          }
        />
        {/* end of private routes */}

        <Route path={URLS.LOGIN} element={<Login />} />
        <Route path={URLS.ORGANIZATION_REGISTRATION} element={<OrganizationRegistration />} />
        <Route path={URLS.RESET_PASSWORD} element={<ResetPasswordContainer />} />
        <Route path={URLS.CHANGE_PASSWORD} element={<ChangePasswordContainer />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </LayoutContainer>
  )
}

export default App
